import React from 'react';
import SyntaxHighlighter from 'react-syntax-highlighter';
import { atomOneDark } from 'react-syntax-highlighter/dist/esm/styles/hljs';
import MermaidRenderer from './MermaidRenderer';
import PlotlyChartRenderer from './PlotlyChartRenderer';

export default class CodeBlock extends React.PureComponent {
  render() {
    const { inline, className, children, ...props } = this.props;

    if (inline) {
      return (
        <code {...props} className={className}>
          {children}
        </code>
      );
    }

    const isMermaid = className?.includes('language-mermaid');

    if (isMermaid) {
      return (
        <MermaidRenderer
          chart={String(children).replace(/\n$/, '')}
          className={className}
        />
      );
    }

    const isPlotlyChart = className?.includes('language-plotly-chart');

    if (isPlotlyChart) {
      return (
        <PlotlyChartRenderer
          chart={String(children).replace(/\n$/, '')}
          className={className}
        />
      );
    }

    const languageMatches = /language-(\w+)/.exec(className || '') ?? [];

    const language = languageMatches ? languageMatches[1] : 'text';

    const isMarkdown = language === 'markdown' || language === 'md';
    // syntax highlighter doesn't support "md" tag, so we need to use the "markdown" tag instead
    const lang = isMarkdown ? 'markdown' : language;

    return (
      <SyntaxHighlighter
        language={lang}
        style={atomOneDark}
        wrapLongLines={isMarkdown}
      >
        {String(children).replace(/\n$/, '')}
      </SyntaxHighlighter>
    );
  }
}
